import { CreateNormativaJsonDto, infoFetchGetNormativaI, infoFetchGetUrlPrefirmadaI, makeNormativa, PresignedUrlResponse, UpdateNormativaJsonDto } from "dtos/normativa";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

const BASE_URL = window.configs.REACT_APP_API;

export const openFile = ({ id }: { id: string | number }) => {
  window.open(
    `${BASE_URL?.slice(0, -1)}${ENDPOINTS.DOCUMENTACION_ADJUNTA_VER_FILE}/${id}`,
    "_blank",
  );
};

export const getDocumentacionFile = async ({
  id,
  fileName,
}: {
  id: string | number;
  fileName: string;
  }) => {
  const response = await sendRequest<any>({
    method: "GET_FILE",
    uri: ENDPOINTS.DOCUMENTACION_ADJUNTA_VER_FILE + "/" + id,
    fileType: "application/pdf",
    fileName,
  });
  return response;
};

export const getNormativasNoAsociadasCantidad = async () => {
  const response = await sendRequest<number>({
    method: "GET",
    uri: ENDPOINTS.NORMATIVAS_NO_ASOCIADAS_CANTIDAD,
  });
  return response;
};

export const getNormativas = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetNormativaI>
  >({
    method: "GET",
    uri: ENDPOINTS.NORMATIVAS,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeNormativa(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const getNormativasJurisdiccionales = async (id: string | number) => {
  const response = await sendRequest<infoFetchGetNormativaI>({
    method: "GET",
    uri: ENDPOINTS.NORMATIVAS_POR_ALCANCE + "/2",
  });
  console.log("Aca estoy", response);
  return makeNormativa(response);
};

export const postNormativa = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetNormativaI>({
    method: "POST",
    uri: ENDPOINTS.NORMATIVAS,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeNormativa(response);
};

// Esta funcion debera de iniciar con los pdf, a los cual le debe de sacar toda la info y pasarla al backend para crear las url prefirmadas
export const getUrlPrefirmada = async (documento: infoFetchGetUrlPrefirmadaI) => {
  // TODO: Log de desarrollo, elimninar luego de validar en DEV
  console.log('documento',documento);
  
  const response = await sendRequest<PresignedUrlResponse[]>({
    method: "POST_JSON",
    uri: ENDPOINTS.NORMATIVAS + "/url-prefirmada",
    params: documento
  });
  // TODO: Log de desarrollo, elimninar luego de validar en DEV
  console.log('response',response);
  
  return response;
};

export const postNormativaV2 = async (normativa: CreateNormativaJsonDto) => {
  // TODO: Log de desarrollo, elimninar luego de validar en DEV
  console.log('normativa',normativa);
  const response = await sendRequest<infoFetchGetNormativaI>({
    method: "POST_JSON",
    uri: ENDPOINTS.NORMATIVAS + "/v2",
    params: normativa
  });
  return makeNormativa(response);
}


export const postNormativaNoAnexo = async ({
  params,
  images,
}: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetNormativaI>({
    method: "POST",
    uri: ENDPOINTS.NORMATIVAS + "/no-anexo",
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeNormativa(response);
};

export const deleteNormativa = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.NORMATIVAS + "/" + id,
  });
  return response;
};

export const putNormativa = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetNormativaI>({
    method: "PUT",
    uri: ENDPOINTS.NORMATIVAS,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  return makeNormativa(response);
};

export const putNormativaV2 = async (normativa: UpdateNormativaJsonDto) => {
    // TODO: Log de desarrollo, elimninar luego de validar en DEV
    console.log('normativa',normativa);
    const response = await sendRequest<infoFetchGetNormativaI>({
      method: "PUT_JSON",
      uri: ENDPOINTS.NORMATIVAS + "/v2",
      params: normativa
    });
    return makeNormativa(response);
}